// Studio-facing English names for the patient language access reviewer.
// Keep these aligned with LANGUAGES in src/i18n/languages.js. These labels do not
// change patient-facing locale names, translation status or enabled language IDs.
export const STUDIO_LANGUAGE_ENGLISH_NAMES = Object.freeze({
  en: 'English',
  pl: 'Polish',
  ro: 'Romanian',
  fr: 'French',
  es: 'Spanish',
  ar: 'Arabic',
  ur: 'Urdu',
  bn: 'Bengali',
  pa: 'Punjabi',
  so: 'Somali',
  pt: 'Portuguese',
  it: 'Italian',
  gu: 'Gujarati',
  tr: 'Turkish',
  fa: 'Persian (Farsi)',
  zh: 'Chinese (Simplified)',
  tl: 'Filipino',
});

export function englishLanguageName(language) {
  return STUDIO_LANGUAGE_ENGLISH_NAMES[language.id] || language.label;
}
